'use strict';

const vex = require('vex-js');
const dialogue = require('vex-dialog');

vex.registerPlugin(dialogue);
vex.defaultOptions.className = 'vex-theme-plain';

module.exports = vex;